import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import PreservativesForm from "../../../components/forms/setup/preservatives/PreservativesForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function PreservativesViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [preservatives, setPreservatives] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getPreservatives = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`preservatives`, payload);
    setLoading(false);
    if (callResult.success) {
      setPreservatives(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createPreservative = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createPreservative", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Preservative added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getPreservatives("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updatePreservative = async function (preservative, values, index) {
    let callResult = await makePutApiCall(
      `preservative/${preservative.id}`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Preservative updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getPreservatives("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddPreservativeSlideOver = () => {
    setSlideOver({
      childComponent: (
        <PreservativesForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createPreservative}
        />
      ),
      open: true,
    });
  };

  const viewPreservativeDetails = async function (preservative, index) {
    setSlideOver({
      childComponent: (
        <PreservativesForm
          preservative={preservative}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updatePreservative}
        />
      ),
      open: true,
    });
  };

  const deletePreservative = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deletePreservative/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getPreservatives(null, 0);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeletePreservative = function (preservative, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deletePreservative(preservative.id, index)}
          message={`Are you sure you want to delete ${preservative.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeletePreservative,
    emptyModal,
    setEmptyModelOpen,
    getPreservatives,
    loading,
    preservatives,
    openAddPreservativeSlideOver,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewPreservativeDetails,
  };
}
